import {
    DisplayCondition,
    InputField
} from '../components/ExpressionBuilder';

export const selectedComboboxGetter = (id: string, list: any[]): {_id: string, name: string} => {
    let selectedObj = {
        name: 'Select Item',
        _id: id || ''
    };
    if (!id) return selectedObj;

    const foundItems = list.find((item) => item._id === id);
    if (foundItems) {
        selectedObj.name = foundItems.name;
    }

    return selectedObj;
};

export function isDynamic(field: any): boolean {
    const dynamicPattern = /\{\{\s*\w+(?:\s*\[\s*['"][^'"]+['"]\s*\])+\s*\}\}|\[\s*dict_get\s*\(\s*\w+\s*,\s*['"][^'"]+['"]\s*\)\s*\]/; // to match {{ context['key'] }} or {{ [dict_get(context, 'key')] }}
    return dynamicPattern.test(field);
}

export function returnIfContext(field: any): string {
    return typeof field === 'string' && isDynamic(field) ? field : '';
}

export function returnIfStatic(field: any, fallback: any): string {
    return isDynamic(field) ? fallback : field;
}

export const parseStringIfCondition = (conditionString: InputField, isCondition: boolean, whichSide: 'leftValue' | 'rightValue' | 'operator') => {
    if (!isCondition) return conditionString?.value || '';
    return conditionString[whichSide] || '';
};

export const displayFieldsBasedOnType = (inputField: InputField): string => {
    if (typeof inputField === 'string') return inputField;

    switch (inputField?.inputType) {
        case 'string':
            return typeof inputField.value === 'string' ? inputField.value : '';
        case 'number':
            return typeof inputField.value === 'number' ? inputField.value.toString() : '';
        case 'boolean':
            return typeof inputField.value === 'boolean' ? inputField.value.toString() : '';
        case 'dropdown':
            return isDynamic(inputField.value) ? inputField.value as string : selectedComboboxGetter(inputField.value as string, inputField?.options || []).name;
        case 'dict':
            return typeof inputField.value === 'object' && inputField.value !== null ? JSON.stringify(inputField.value) : '';
        default:
            return '';
    }
};

export function shouldDisplay(condition: DisplayCondition, formValues: InputField[]): boolean {
    if (!condition || !condition.dependsOn) return true;

    const currentValue = formValues.find(field => field.inputName === condition.dependsOn)?.value;

    let result = false;

    switch (condition.condition) {
        case 'equals':
            result = currentValue === condition.value;
            break;

        case 'not_equals':
            result = currentValue !== condition.value;
            break;

        case 'in':
            result = Array.isArray(condition.value) && condition.value.includes(currentValue);
            break;

        case 'not_in':
            result = Array.isArray(condition.value) && !condition.value.includes(currentValue);
            break;

        case 'greater_than':
            result = typeof currentValue === 'number' && typeof condition.value === 'number' && currentValue > condition.value;
            break;

        case 'less_than':
            result = typeof currentValue === 'number' && typeof condition.value === 'number' && currentValue < condition.value;
            break;

        default:
            result = false;
    }

    return condition.then === 'show' ? result : !result;
}

export const getTypeColor = (type: string) => {
  if (typeof type !== 'string') return 'bg-slate-500/10 text-slate-700 dark:text-slate-400 border-slate-500/20';

  switch (type?.toLowerCase()) {
    case 'string':
      return 'bg-emerald-500/10 text-emerald-700 dark:text-emerald-400 border-emerald-500/20';
    case 'number':
      return 'bg-blue-500/10 text-blue-700 dark:text-blue-400 border-blue-500/20';
    case 'dict':
      return 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20';
    case 'list':
      return 'bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20';
    case 'dropdown':
          return 'bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20';
    case 'condition':
      return 'bg-rose-500/10 text-rose-700 dark:text-rose-400 border-rose-500/20';
    case 'object':
        return 'bg-amber-500/10 text-amber-700 dark:text-amber-400 border-amber-500/20';
    case 'array':
        return 'bg-purple-500/10 text-purple-700 dark:text-purple-400 border-purple-500/20';
    case 'boolean':
        return 'bg-rose-500/10 text-rose-700 dark:text-rose-400 border-rose-500/20';
    default:
      return 'bg-slate-500/10 text-slate-700 dark:text-slate-400 border-slate-500/20';
  }
};